import * as React from 'react';
import { Checkbox } from '@cian/ui-kit/checkbox';
import * as styles from './styles.css';
import { UiKitContext } from '@cian/ui-kit/internal/context';

export interface ICheckMarkProps {
  checked: boolean;
}

export const CheckMark: React.FC<ICheckMarkProps> = ({ checked }) => {
  return (
    <UiKitContext.Provider
      value={{
        deviceType: 'phone',
        useStaticDeviceType: true,
      }}
    >
      <div className={styles['container']}>
        <Checkbox checked={checked} />
      </div>
    </UiKitContext.Provider>
  );
};

CheckMark.displayName = 'CheckMark';
